<style lang="scss" scoped="">

  $leftWidth: 0;
  .content-part {
    .content-left {
      width: $leftWidth;
    }

    .content-right {
      > h3 {
        left: $leftWidth;
      }

      left: $leftWidth;
    }
  }

  .min-gutter {
    .el-form-item {
      margin-bottom: 20px;
    }
  }

  .el-form .el-select {
    display: block;
  }

  .tr-bg {
    background: #eeeeee;
  }

  .qp-box {
    margin-bottom: 40px;
    padding: 20px;
    margin-left: 40px;
    box-shadow: 4px 4px 2px 0 #ddd;
  }

  .base-pic-list {
    padding-top: 10px;
    display: flex;
    flex-wrap: wrap;

    .base-pic-item {
      border: 1px solid #eee;
      position: relative;
      cursor: pointer;
      width: 180px;
      margin: 5px;
      padding: 10px;
      font-size: 12px;

      img {
        width: 180px;
        height: 180px;
        display: block;
        background: #ccc;

      }
    }
  }
</style>
<template>
  <div>
    <div class="content-part">
      <div class="content-right min-gutter">
        <h3>新增上报库存</h3>
        <el-form ref="batchForm" :rules="rules" :model="form" label-width="140px"
                 class="min-gutter"
                 @submit.prevent="submitForm()" onsubmit="return false" style="padding-right: 20px">
          <el-form-item label="货品" prop="goodsId">
            <el-select placeholder="请输入名称搜索货品" v-model="form.goodsId" filterable remote
                       :remote-method="queryManageGoodsNew" @change="goodsIdChange"
                       :clearable="true" popperClass="custom-select" @click.native.once="queryManageGoodsNew('')">
              <el-option :label="item.name" :value="item.goodsId" :key="item.id" v-for="item in manageGoods">
                <manage-goods-option :optionItem="item"/>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="批号" prop="batchNumberId">
            <el-select v-model="form.batchNumberId" filterable clearable remote
                       :remoteMethod="queryDhsBatchNumbers" placeholder="请输入批号名称搜索批号">
              <el-option v-for="item in batchNumberList" :value="item.id" :key="item.id" :label="item.batchNumber">
                {{ item.batchNumber }}
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="盘点数量" prop="count">
            <el-input type="number" placeholder="请输入盘点数量" v-model.trim="form.count"></el-input>
          </el-form-item>
          <el-form-item label="物流中心">
            <el-select :clearable="true" filterable v-model="form.logisticsCentreId"
                       placeholder="请输入名称搜索物流中心" popperClass="good-selects">
              <el-option :key="org.id" :label="org.name" :value="org.id" v-for="org in logisticsCenter">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="供货单位">
            <el-select filterable remote placeholder="请输入名称搜索供货单位" :remote-method="queryDownListNew" :clearable="true"
                       v-model="form.supplyManufacturersId" popperClass="good-selects">
              <el-option :value="org.id" :key="org.id" :label="org.name" v-for="org in bizOrgList">
                <div style="overflow: hidden">
                  <span class="pull-left" style="clear: right">{{org.name}}</span>
                </div>
                <div style="overflow: hidden">
                  <span class="select-other-info pull-left">
                    <span>系统代码:</span>{{org.manufacturerCode}}
                  </span>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click.prevent.stop="submitForm" :disabled="doing">保存</el-button>
            <el-button @click="$emit('close')">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
  import {BspInventory, http} from '@/resources';
  import methodsMixin from '@/mixins/methodsMinix';

  export default {
    props: {
      currentItem: Object,
      showAddPart: Boolean
    },
    mixins: [methodsMixin],
    data() {
      return {
        form: {
          goodsId: '',
          batchNumberId: '',
          logisticsCentreId: '',
          supplyManufacturersId: '',
          count: ''
        },
        rules: {
          goodsId: [
            {required: true, message: '请选择货品', trigger: 'change'}
          ],
          batchNumberId: [
            {required: true, message: '请选择批号', trigger: 'change'}
          ],
          count: [
            {required: true, message: '请输入盘点数量', trigger: 'blur'}
          ]
        },
        manageGoods: [],
        index: 0,
        doing: false
      };
    },
    watch: {
      currentItem(val) {
        if (!this.showAddPart) return;
        this.form = Object.assign({}, val);
        this.queryLogisticsCenter();
        if (!val.id) {
          this.resetForm();
        } else {

        }
      }
    },
    methods: {
      queryDownListNew(query) {
        let params = {
          keyWord: query,
          orgAuditStatus: 1,
          deleteFlag: false,
          orgId: this.$store.state.user.userCompanyAddress
        };
        this.queryBizOrgList(params);
      },
      queryManageGoodsNew(query) {
        let user = this.$store.state.user;
        if (!user.userCompanyAddress) return;
        let params = {
          orgId: user.userCompanyAddress,
          deleteFlag: false,
          keyWord: query,
          auditStatus: '1'
        };
        return this.$http.get('dhs-operation-goods/checked-pager', {params}).then(res => {
          this.manageGoods = res.data.list;
        });
      },
      queryDhsBatchNumbers(val) {
        if (!this.form.goodsId) {
          this.batchNumberList = [];
          this.$notify.info('请选择货品');
          return;
        }
        this.queryDhsBatchNumberList({
          keyWord: val,
          goodsId: this.form.goodsId
        });
      },
      goodsIdChange(val) {
        this.batchNumberList = [];
        this.form.batchNumberId = '';
        if (!val) return;
        this.queryDhsBatchNumbers();
      },
      resetForm() {
        this.form = {
          goodsId: '',
          batchNumberId: '',
          logisticsCentreId: '',
          supplyManufacturersId: '',
          count: ''
        };
        this.$nextTick(() => {
          this.$refs.batchForm.clearValidate();
        });
      },
      submitForm() {
        this.$refs['batchForm'].validate(valid => {
          if (!valid) {
            this.index = 0;
            return;
          }

          this.doing = true;
          if (this.actionType === 'edit') {
            http.put('/dhs-batch-number/' + this.form.id, this.form).then(res => {
              this.$notify.success({
                message: '修改成功'
              });
              this.doing = false;
              this.$emit('change', this.id);
              this.$emit('close');
            }).catch(err => {
              this.doing = false;
              this.$notify.error({
                message: err.response.data && err.response.data.msg || '修改失败'
              });
            });
          } else {
            BspInventory.save(this.form).then(res => {
              this.$notify.success({
                message: '新增成功'
              });
              this.doing = false;
              this.$emit('change', res.data);
              this.$emit('close');
              this.resetForm();
            }).catch(err => {
              this.doing = false;
              this.$notify.error({
                message: err.response.data && err.response.data.msg || '新增失败'
              });
            });
          }
        });
      }
    }
  };
</script>
